<template>
  <div class="footer-sidebar d-flex flex-column justify-content-between">
    <ul class="nav nav-pills flex-column">
      <li class="nav-item parent">
        <a
          class="d-flex justify-content-between align-items-center"
          href="#"
          @click.prevent="isOpen = !isOpen"
          :class="{ open: isOpen }"
        >
          <span
            ><i
              class="bi bi-question-square"
              style="margin-right: 10px"
            ></i>
            {{ t('common.help') }}</span
          >
          <i class="bi bi-caret-down-fill"></i>
        </a>
        <Transition name="accordion">
          <ul
            class="list-unstyled"
            v-show="isOpen"
          >
            <li class="children">
              <a
                href="/Инструкция RTMS v.1.pdf"
                download
                >{{ t('manualRtms') }}</a
              >
            </li>
            <li class="children">
              <RouterLink to="/tickets">{{ t('myTickets') }}</RouterLink>
            </li>
            <li class="children">
              <RouterLink :to="{ name: 'tickets.create' }">{{ t('createTicket') }}</RouterLink>
            </li>
            <li
              v-if="isSupport"
              class="children"
            >
              <RouterLink :to="{ name: 'tickets.support' }">{{ t('allTicketsSupport') }}</RouterLink>
            </li>
          </ul>
        </Transition>
      </li>
    </ul>
    <div class="bottom-block">
      <p class="m-0">
        SOYKA:RTMS {{ VERSION }}<br />
        {{ t('common.developedBy') }}
        <a
          href="//atd.systems"
          target="_blank"
          class="fs-14 link-danger"
          >ATD.Systems</a
        >
      </p>
    </div>
  </div>
</template>

<script setup>
import { shallowRef, computed } from 'vue'
import { RouterLink } from 'vue-router'
import { useI18n } from 'vue-i18n'
import config from '@/config'
import { useUserStore } from '@/stores/user'

const { t } = useI18n()
const isOpen = shallowRef(false)
const VERSION = config.VITE_VERSION || 'v1.0.24'

const userStore = useUserStore()
const isSupport = computed(() => {
  const roles = userStore.user?.roles || []
  return roles.some(r => ['tickets_support', 'sa'].includes(r.name))
})
</script>

<i18n>
{
  "ru": {
    "manualRtms": "Инструкция RTMS",
    "myTickets": "Мои тикеты",
    "createTicket": "Создать тикет",
    "allTicketsSupport": "Все тикеты (поддержка)"
  },
  "en": {
    "manualRtms": "RTMS Manual",
    "myTickets": "My tickets",
    "createTicket": "Create ticket",
    "allTicketsSupport": "All tickets (support)"
  }
}
</i18n>
